import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
	useGetAllGeofencesQuery,
	useGetGeofencesByDeviceQuery,
	useGetUsersGeofencesQuery,
} from "../../../Redux/service/Geofences/Geofences";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";

export default function GeofencesMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);

	const [isOpen, setIsOpen] = useState(false);
	const [selectedGeofences, setSelectedGeofences] = useState([]);
	const [groups, setGroups] = useState([]);
	let { data: AdminGeofences, refetch: AdminGeoRefetch } =
		useGetAllGeofencesQuery(undefined, { refetchOnMountOrArgChange: true });
	let {
		data: GeofencesVehicles,
		refetch: GeofencesVehiclesRefetch,
		isUninitialized: isGeoUninit,
	} = useGetGeofencesByDeviceQuery(vehicleId, {
		skip: !vehicleId,
		refetchOnMountOrArgChange: true,
	});
	let {
		data: UsersGeofences,
		refetch: UsersGeoRefetch,
		isUninitialized: isUsersUninit,
	} = useGetUsersGeofencesQuery(userId, {
		skip: !userId,
		refetchOnMountOrArgChange: true,
	});
	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	const isFirstMount = useRef(true);
	useEffect(() => {
		if (AdminGeofences && UsersGeofences) {
			const merged = [...AdminGeofences, ...UsersGeofences];
			const unique = merged.filter(
				(item, index, self) =>
					index === self.findIndex((t) => t.id === item.id),
			);
			setMergedData(unique);
		}
	}, [AdminGeofences, UsersGeofences]);
	useEffect(() => {
		if (type === "users") {
			if (UsersGeofences) {
				setSelectedGeofences(UsersGeofences?.map((i) => i.id));
			}
		} else if (type === "vehicles") {
			if (GeofencesVehicles) {
				setSelectedGeofences(GeofencesVehicles?.map((i) => i.id));
			}
		}
	}, [UsersGeofences, GeofencesVehicles, type]);
	useEffect(() => {
		if (isFirstMount.current || AdminGeoRefetch || UsersGeoRefetch) {
			if (mergedData?.length === 0) {
				setGroups(
					(AdminGeofences || UsersGeofences)?.map((i) => ({
						value: i.id,
						label: i.name,
					})),
				);
			} else {
				setGroups(
					mergedData?.map((i) => ({
						value: i.id,
						label: i.name,
					})),
				);
			}
		}
		isFirstMount.current = false;
	}, [
		mergedData,
		AdminGeoRefetch,
		UsersGeoRefetch,
		AdminGeofences,
		UsersGeofences,
	]);
	useEffect(() => {
		if (!isLinking) return;

		if (type === "vehicles" && !isGeoUninit) {
			GeofencesVehiclesRefetch();
		}

		if (type === "users" && !isUsersUninit) {
			UsersGeoRefetch();
		}
	}, [
		GeofencesVehiclesRefetch,
		UsersGeoRefetch,
		isGeoUninit,
		isUsersUninit,
		isLinking,
		type,
	]);

	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedGeofences((prev) => [...prev, value]);
						handleLink(value, "geofence", "Geofence");
					}}
					onDeselect={(value) => {
						setSelectedGeofences((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "geofence", "Geofence");
					}}
					value={selectedGeofences || ""}
					// ✅ Local state controls selection
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
